import { Pipe, PipeTransform } from '@angular/core';
import { CartItemGroup } from "../../../cart/cart.model";

@Pipe({
  name: 'disableExportUnapprovedGroup'
})
export class DisableExportUnapprovedGroupPipe implements PipeTransform {

  transform(group: CartItemGroup, exportsRequireApproval: boolean): boolean {
	  if (exportsRequireApproval && (group.items.length > 0 || group.subgroups.length > 0)) {
		  return group.items?.every(item => item.approved !== true) &&
				 group.subgroups?.every(subgroup => subgroup.items?.every(item => item.approved !== true));
	  }
	  return false;
  }

}
